
export default {
  props: ['innerStyle', 'imageUrl', 'innerClass', 'width', 'height', 'lazy', 'alt'],
  data() {
    return {}
  },
  methods: {
    imageProps() {
      if (process.client) {
        try {
          const { height, imageUrl, lazy = true, innerClass, alt } = this.$props
          const tagProps = {}
          tagProps['alt'] = alt
          tagProps['class'] = innerClass
          tagProps['loading'] = 'lazy'
          if (!lazy) {
            delete tagProps['loading']
          }
          if (imageUrl) {
            const changeUrl = new URL(imageUrl)
            const urlParams = {}
            if (imageUrl !== undefined) {
              const extension = imageUrl.match(/\/?(.*)\.(.*)/)[2].toLowerCase()
              if (extension !== 'webp') {
                urlParams['f'] = 'webp'
              }
            }
            // if (width) {
            //   urlParams['w'] = width
            // }

            if (height) {
              urlParams['h'] = height
            }
            urlParams['q'] = 85
            for (const key in urlParams) {
              changeUrl.searchParams.set(key, urlParams[key])
            }
            tagProps['src'] = changeUrl.href.replace('https://cfw-makesta-real-production.s3.ap-northeast-2.amazonaws.com', 'https://d238m8ukn6hkhb.cloudfront.net')
          }
          return tagProps
        } catch (e) {
          console.log('image test', e)
        }
      }
    }
  }
}
